import { useEditor, useNode } from '@craftjs/core';
import { Spacing } from '../settings/SpacingSettings/SpacingSettings';
import { DimentionProps } from '@/components/editor/settings/DimentionSettings/types';
import useNormalizeDimentions from '@/components/editor/settings/DimentionSettings/useNormalizeDimentions';
import useNormalizeSpacing from '@/components/editor/settings/SpacingSettings/useNormalizeSpacing';
import useNormalizeBorderRadius from '@/components/editor/settings/BorderRadius/useNormalizeBorderRadius';
import { BorderRadius } from '@/components/editor/settings/BorderRadius/BorderRadiusSettings';
import ImageSettings, {
  ImageProps,
} from '@/components/editor/settings/ImageSettings/ImageSettings';
import useNormalizeImageSettings from '@/components/editor/settings/ImageSettings/useNormalizeImageSettings';
import useResponsiveValues from '../hooks/useResponsiveValues';
import { useState } from 'react';
import { ButtonBase, Dialog } from '@mui/material';
import { CssClass } from '../settings/ClassSettings';

export type Props = Partial<
  ImageProps & DimentionProps & BorderRadius & Spacing & CssClass
>;

const ImageBlock = (props: Props) => {
  const responsive = useResponsiveValues();
  const dimentions = useNormalizeDimentions(props);
  const spacing = useNormalizeSpacing(props);
  const borderRadius = useNormalizeBorderRadius(props);
  const { src, modal, href, ...imageProps } = useNormalizeImageSettings(props);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { query } = useEditor();
  const {
    id,
    connectors: { connect, drag },
  } = useNode((state) => {
    return {
      hasSelectedNode: state.events.selected,
      hasDraggedNode: state.events.dragged,
    };
  });

  const isEditorEnabled = query.getOptions().enabled;

  const Image = () => (
    <img
      // className={`img ${responsive.getValue(cssClass)}`}
      style={{
        ...spacing,
        ...dimentions,
        ...borderRadius,
        ...imageProps,
      }}
      src={responsive.getValue(src as string) ?? '/placeholder.png'}
    />
  );

  return (
    <div
      className={`img ${responsive.getValue(props.cssClass)}`}
      ref={(ref) => connect(drag(ref))}
      key={`${id}-${responsive.viewport}`}
      style={{
        ...dimentions,
      }}
    >
      {modal ? (
        <>
          <ButtonBase
            disableRipple
            disabled={isEditorEnabled}
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            <Image />
          </ButtonBase>
          <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <img
              width="auto"
              height="500"
              src={responsive.getValue(src as string) ?? '/placeholder.png'}
            />
          </Dialog>
        </>
      ) : (
        href ? <a href={href} target="_blank"><Image /></a> : <Image /> 
      )}
    </div>
  );
};

ImageBlock.craft = {
  displayName: 'Imagen',
  props: {
    dimentions: {
      width: '100',
      height: 'unset',
      widthType: '%',
      heightType: 'px',
    },
  },
  related: {
    settings: ImageSettings,
  },
};

export default ImageBlock;
